var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "canvasWrapper",
    attrs: {
      "id": "canvasWrapper"
    },
    on: {
      "mouseenter": _vm.mouseEnter,
      "mouseleave": _vm.mouseLeave,
      "wheel": function wheel($event) {
        $event.preventDefault();
        return _vm.zooming($event);
      }
    }
  }, [_c('canvas', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:tap",
      value: _vm.hammerTap,
      expression: "hammerTap",
      arg: "tap"
    }, {
      name: "hammer",
      rawName: "v-hammer:pan.horizontal",
      value: _vm.hammerPan,
      expression: "hammerPan",
      arg: "pan",
      modifiers: {
        "horizontal": true
      }
    }, {
      name: "hammer",
      rawName: "v-hammer:pinch",
      value: _vm.hammerPinchMove,
      expression: "hammerPinchMove",
      arg: "pinch"
    }, {
      name: "hammer",
      rawName: "v-hammer:pinchin",
      value: _vm.hammerPinchIn,
      expression: "hammerPinchIn",
      arg: "pinchin"
    }, {
      name: "hammer",
      rawName: "v-hammer:pinchout",
      value: _vm.hammerPinchOut,
      expression: "hammerPinchOut",
      arg: "pinchout"
    }, {
      name: "hammer",
      rawName: "v-hammer:panstart",
      value: _vm.hammerPanStart,
      expression: "hammerPanStart",
      arg: "panstart"
    }, {
      name: "hammer",
      rawName: "v-hammer:panend",
      value: _vm.hammerPanEnd,
      expression: "hammerPanEnd",
      arg: "panend"
    }],
    ref: "capustaCanvas",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }), !_vm.DEVICE.isMobile ? _c('div', {
    attrs: {
      "id": "controllerSwitch"
    }
  }, _vm._l(_vm.chartData, function (el, idx) {
    return _c('a', {
      key: idx,
      class: {
        'selected': el.show
      },
      on: {
        "click": function click($event) {
          return _vm.controllerSwitchClickHandler(el.name);
        }
      }
    }, [_c('em', {
      style: {
        background: el.colorArc
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t(el.name)))])]);
  }), 0) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showHint,
      expression: "showHint"
    }],
    style: {
      left: !_vm.DEVICE.isMobile ? "".concat(_vm.hint.x - 103, "px") : 0,
      top: "".concat(_vm.hint.y, "px"),
      right: _vm.DEVICE.isMobile && 0,
      background: _vm.COLORS.controllerBg
    },
    attrs: {
      "id": "hint"
    }
  }, [_c('div', _vm._l(_vm.SLICED_MAIN, function (item, idx) {
    return _c('div', {
      key: idx
    }, [item.length ? [_c('h4', {
      style: {
        color: _vm.chartData[idx].colorArc
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.chartData[idx].name)) + " "), _vm.chartData[idx].name === _vm.$t('common.balance') ? _c('em', {
      domProps: {
        "textContent": _vm._s(_vm.displayAmount(item[_vm.hint.index].y))
      }
    }) : _vm._e()]), _vm.chartData[idx].name === _vm.$t('common.balance') ? [_c('section', [_c('span', [_vm._v(_vm._s(_vm.$t('common.outputs')) + ":")]), _c('em', [_vm._v(_vm._s(_vm.$t('common.pieces', {
      count: item[_vm.hint.index].count
    })))]), _c('br')]), _c('section', [_c('span', [_vm._v(_vm._s(_vm.$t('for.amount')) + ":")]), _c('em', {
      domProps: {
        "textContent": _vm._s(_vm.displayAmount(item[_vm.hint.index].payout))
      }
    })])] : [_c('section', [_c('span', [_vm._v(_vm._s(_vm.$t('of.transfers')) + ":")]), _c('em', [_vm._v(_vm._s(_vm.$t('common.pieces', {
      count: item[_vm.hint.index].count
    })))]), _c('br')]), _c('section', [_c('span', [_vm._v(_vm._s(_vm.$t('for.amount')) + ":")]), _c('em', {
      domProps: {
        "textContent": _vm._s(_vm.displayAmount(item[_vm.hint.index].y))
      }
    })])]] : _vm._e()], 2);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }